export const BREAKPOINT = {
  SMALL: '530px',
  MEDIUM: '640px',
  MEDIUM_LARGE: '850px'

}

export const EMR_SUPPORT = {
  IS_SUPPORTED: 'IS_SUPPORTED',
  WILL_SUPPORT: 'WILL_SUPPORT',
  NOT_SUPPORTED: 'NOT_SUPPORTED'
}

// TODO update values of EMRTypes
export const EMR_TYPE = [
  { name: 'AllScripts', value: 'ALLSCRIPTS', support: EMR_SUPPORT.WILL_SUPPORT },
  { name: 'Athena', value: 'ATHENA', support: EMR_SUPPORT.IS_SUPPORTED },
  { name: 'Cerner', value: 'CERNER', support: EMR_SUPPORT.WILL_SUPPORT },
  { name: 'eCW', value: 'UNKNOWN', support: EMR_SUPPORT.WILL_SUPPORT },
  { name: 'Elation', value: 'ELATION', support: EMR_SUPPORT.IS_SUPPORTED },
  { name: 'Epic', value: 'EPIC', support: EMR_SUPPORT.WILL_SUPPORT },
  { name: 'Greenway', value: 'GREENWAY', support: EMR_SUPPORT.NOT_SUPPORTED },
  { name: 'NextGen', value: 'NEXTGEN', support: EMR_SUPPORT.NOT_SUPPORTED },
  { name: 'Meditech', value: 'MEDITECH', support: EMR_SUPPORT.NOT_SUPPORTED },
  { name: 'Other', value: 'UNKNOWN', support: EMR_SUPPORT.NOT_SUPPORTED }
]

export const ONBOARD_TYPE = {
  SUKI: 'SUKI',
  GCP: 'GCP'
}

export const VERIFY_TOKEN_PAGE = {
  '/demo-app': ONBOARD_TYPE.SUKI,
  '/register': ONBOARD_TYPE.SUKI,

  '/gcp-register': ONBOARD_TYPE.SUKI
}

export const REGISTER_STAGE = {
  DEFAULT_STAGE: 'DEFAULT_STAGE',
  DEMO_EMAIL: 'DEMO_EMAIL',
  DEMO_SUBMIT: 'DEMO_SUBMIT',
  REGISTER_SUBMIT: 'REGISTER_SUBMIT',
  EMR_SEARCH: 'EMR_SEARCH',
  EMR_LINKED: 'EMR_LINKED',
  EMR_APPTS_VERIFIED: 'EMR_APPTS_VERIFIED',
  EMR_NOTES_VERIFIED: 'EMR_NOTES_VERIFIED',

  // for frontend only
  GET_SUKI: 'GET_SUKI',
  FINISHED: 'FINISHED'
}
